import { defineStore } from 'pinia'

import type { ReferralStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useReferralStore = defineStore('referral', {
  state: (): ReferralStore => ({
    loading: false,
    loaded: false,
    inviteProcessing: false,
    creditsAnimation: false,
    balanceAnimation: false,
    balance: 0,
    previousBalance: 0,
    referralLink: '',
    savings: [],
    referrals: [],
  }),
  actions,
  getters,
})
